if (!customElements.get('card-variant-select')) {
    customElements.define('card-variant-select', class CardVariantSelect extends HTMLElement {
        constructor() {
            super();
            this.radios = this.querySelectorAll('input[type="radio"]');
            this.form = this.closest('form');
            this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
            this.button = this.form ? this.form.querySelector('button[name="add"]') : null;
            this.card = this.closest('.product-card');
            this.radios.forEach((radio) => {
                radio.addEventListener('change', this.onChange.bind(this));
            });
        }

        onChange(evt) {
            const radio = evt.target;
            if (this.idInput) {
                this.idInput.value = radio.value;
            }
            this.updateButton(radio.dataset.available === 'true');
            this.updatePrice(radio.dataset.price);
        }

        updateButton(available) {
            if (!this.button) return;
            if (available) {
                this.button.disabled = false;
                if (this.button.dataset.addLabel) {
                    this.button.textContent = this.button.dataset.addLabel;
                }
            } else {
                this.button.disabled = true;
                if (this.button.dataset.soldoutLabel) {
                    this.button.textContent = this.button.dataset.soldoutLabel;
                }
            }
        }

        updatePrice(price) {
            if (!this.card || !price) return;
            const priceEl = this.card.querySelector('.product-card-price-regular');
            if (priceEl) {
                priceEl.innerHTML = price;
            }
        }
    });
}
